<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="title"><a id="pageiii"></a>Killing<br/>Pablo</h1>
<h3 class="subtitle">The Hunt for the<br/>World’s Greatest Outlaw</h3>
<h2 class="authors">Mark<br/>Bowden</h2>
<p class="center"><img alt="logo" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?14361ca5